import { FilterFormButtons } from '../../actions/button/FilterFormButtons'
import { useFormikContext } from '../../hooks/useFormikContext'

type Props = {
  onAdditionalReset?: () => void
}

export const FormikFilterFormButtons = ({ onAdditionalReset }: Props) => {
  const { initialValues, resetForm, isSubmitting } = useFormikContext()

  return (
    <FilterFormButtons
      isLoading={isSubmitting}
      onReset={() => {
        resetForm({ values: initialValues })
        onAdditionalReset?.()
      }}
    />
  )
}
